import React from 'react';
import { useLocation } from 'react-router-dom';
import { useFamily } from '../contexts/FamilyContext';

const Footer = () => {
  const location = useLocation();
  const { currentFamily } = useFamily();
  const currentYear = new Date().getFullYear();
  const isLoginPage = location.pathname === '/login';

  // Use login page colors on login page, match theme background elsewhere
  // Footer colors can be customized via environment variables or the family dashboard
  const loginFooterColor = process.env.REACT_APP_FOOTER_LOGIN_COLOR || '#5ce1e6';
  const loginFooterBorder = process.env.REACT_APP_FOOTER_LOGIN_BORDER_COLOR || '#4dd1d6';
  const envFooterColor = process.env.REACT_APP_FOOTER_COLOR || process.env.REACT_APP_THEME_APPBAR_COLOR || '#9D8B70';
  const appFooterColor = currentFamily?.footer_color || envFooterColor;
  const appFooterBorder = currentFamily?.footer_color || process.env.REACT_APP_FOOTER_BORDER_COLOR || process.env.REACT_APP_THEME_APPBAR_COLOR || '#8B7D6B';
  const footerTextColor = process.env.REACT_APP_FOOTER_TEXT_COLOR || process.env.REACT_APP_THEME_BUTTON_TEXT_COLOR || '#FFFFFF';

  const backgroundColor = isLoginPage ? loginFooterColor : appFooterColor;
  const borderTopColor = isLoginPage ? loginFooterBorder : appFooterBorder;
  const textColor = footerTextColor;
  
  return (
    <footer
      id="app-footer"
      data-testid="app-footer"
      style={{
        marginTop: 'auto',
        padding: '16px',
        backgroundColor: backgroundColor,
        color: textColor,
        textAlign: 'center',
        width: '100%',
        minHeight: '60px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        boxSizing: 'border-box',
        borderTop: `2px solid ${borderTopColor}`,
        position: 'relative',
        zIndex: 1000,
      }}
    >
      <div style={{ fontWeight: 500, fontSize: '14px' }}>
        © {currentYear} RockStar Social
      </div>
    </footer>
  );
};

export default Footer;
